<template>
<div id="login">
  <div class="container">
    <div class="jumbotron">
      <div class="row">
        <div class="col-md-offset-3 col-md-6 text-center">
          <h1>SPIADI</h1>
          <p>
            Surveillance et Prévention des Infections Associées
            aux Dispositifs Invasifs
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-offset-1 col-xs-10 col-sm-offset-2
                  col-sm-8 col-md-offset-4 col-md-4">
        <div class="panel panel-default">
          <div class="panel-body">
            <h4><strong>Identification</strong></h4>
            <div v-if="showPasswordReset">
              <alert type="info">
                <p><strong>Bravo !</strong></p>
                <p>
                  Votre mot de passe a bien été mis à jour,
                  vous pouvez immédiatement vous connecter
                  à l'aide du formulaire ci-dessous.
                </p>
              </alert>
            </div>
            <div v-else>
              <alert type="warning">
                <p>
                  Si vous ne possédez pas d'identifiants pour vous connecter,
                  veuillez commencer par
                  <router-link class="a" to="/newaccount">
                    créer votre compte.
                  </router-link>
                </p>
              </alert>
            </div>
            <p>
              Veuillez vous connecter avec votre adresse e-mail et votre mot de
              passe.
            </p>
            <div class="form-group"
                 :class="{ 'has-error': emailError }">
              <input required
                     id="email"
                     tabindex="1"
                     autofocus
                     class="form-control"
                     v-model.trim="email"
                     :disabled="waiting"
                     type="email"
                     @blur="checkEmail()"
                     @keyup.enter="login"
                     placeholder="Adresse e-mail"/>
            </div>
            <div class="form-group"
                 :class="{ 'has-error': passwordError }">
              <input required
                     id="password"
                     tabindex="1"
                     class="form-control"
                     :disabled="waiting"
                     type="password"
                     v-model="password"
                     @keyup.enter="login"
                     placeholder="Mot de passe"/>
            </div>
            <div class="form-group" v-show="false">
              <input required
                     tabindex="-1"
                     autocomplete="off"
                     id="website"
                     :disabled="waiting"
                     class="form-control"
                     v-model="website"
                     placeholder="empty"/>
            </div>
            <collapse v-model="showError">
              <alert type="danger">
                <strong>{{ errorTitle }}</strong>
                <p>{{ error }}</p>
              </alert>
            </collapse>
            <btn id="login-button"
                 type="success"
                 tabindex="1"
                 :disabled="waiting"
                 block
                 @click="login">Se connecter</btn>
            <div class="row">
              <router-link class="col-xs-12" to="/forgotpassword"
               active-class="active">
                <a>Mot de passe oublié</a>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import tools from '@/sui/tools/main'

import { mapGetters } from 'vuex'

export default {
  name: 'login',

  data () {
    return {
      email: '',
      password: '',
      website: '',
      emailError: false,
      passwordError: false,
      errorTitle: '',
      error: '',
      waiting: false
    }
  },

  created () {
    if (this.$store.getters['user/isSessionExpired']) {
      this.errorTitle = 'Session expirée.'
      this.error = 'Merci de vous reconnecter.'
    }
  },

  computed: {
    showError: function () {
      return this.error !== '' || this.errorTitle !== ''
    },
    ...mapGetters({
      showPasswordReset: 'password/isReset'
    })
  },

  methods: {
    login: function () {
      this.errorTitle = ''
      this.error = ''
      if (!this.checkFormContent()) {
        return
      }

      this.waiting = true
      this.emailError = this.passwordError = false
      const request = {
        email: this.email,
        password: this.password
      }
      let instance = this
      this.$store.dispatch('user/login', request).then(
        (response) => {
          instance.waiting = false
          if (response.data.err != null) {
            instance.emailError = true
            instance.passwordError = true
            instance.errorTitle = 'Echec de la connexion.'
            instance.error = 'Adresse e-mail ou mot de passe incorrect.'
          } else {
            const query = instance.$route.query
            let destination = query.to != null
              ? query.to : '/establishments'
            instance.$router.push(destination)
          }
        }
      ).catch(function (e) {
        instance.waiting = false
        if (e.status === 500) {
          instance.errorTitle = 'Erreur interne.'
          instance.error = `Si cette erreur persiste, merci de contacter
un administrateur.`
        } else {
          instance.errorTitle = 'Serveur injoignable.'
          instance.error = `Merci de vérifier votre connexion internet.`
        }
      })
    },

    checkFormContent: function () {
      return (this.website === '') && this.checkEmail() && this.checkPassword()
    },

    checkPassword: function () {
      this.passwordError = (this.password === '')
      this.error = (this.passwordError) ? 'Aucun mot de passe saisi.' : ''
      this.errorTitle = ''

      return !this.passwordError
    },

    checkEmail: function () {
      this.emailError = (this.email === '' || !tools.isEmailValid(this.email))
      this.error = (this.emailError)
        ? 'L\'adresse e-mail saisie est invalide.' : ''
      this.errorTitle = ''

      return !this.emailError
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#login {
    min-height: 100vh;
    background-color: @base;

    .jumbotron {
        margin-bottom: 0rem;
    }

    #login-button {
        margin-bottom: 1rem;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
}
</style>
